/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'project-contributors-picker.done': 'Erledigt',
  'project-contributors-picker.go-back-label': 'Zurück',
  'project-contributors-picker.header': 'Wählen Sie Mitglieder des Projekts aus',
  'project-contributors-picker.your-teams-secondary-text':
    '{membersCount, plural, one {{membersCount,number} Mitglied} other {{membersCount,number} Mitglieder}}',
  'project-contributors-picker.your-teams-secondary-text-focused':
    '{membersCount, plural, one {Aus {membersCount,number} Mitglied auswählen} other {Aus {membersCount,number} Mitgliedern auswählen}}',
  'project-contributors-picker.your-teams-title': 'Ihre Teams',
  'project-fields.common.generic-error.description':
    'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
  'project-fields.common.generic-error.title': 'Etwas ist schiefgelaufen',
  'project-fields.link-item.delete-label': 'Löschen',
  'project-fields.link-item.edit-label': 'Bearbeiten',
  'project-fields.project-contributes-to.add-goal-title': 'Ziel hinzufügen',
  'project-fields.project-contributes-to.empty-title': 'Keine Ziele',
  'project-fields.project-contributes-to.title': 'Trägt bei zu',
  'project-fields.project-contributors.add-contributors-title': 'Beitragende hinzufügen',
  'project-fields.project-contributors.empty-title': 'Keine Beitragenden',
  'project-fields.project-contributors.remove-contributor': 'Beitragenden entfernen',
  'project-fields.project-contributors.remove-contributor-error-message': 'Beitragender konnte nicht entfernt werden',
  'project-fields.project-contributors.remove-team': 'Team entfernen',
  'project-fields.project-contributors.show-more': 'Mehr anzeigen',
  'project-fields.project-contributors.title': 'Beitragende',
  'project-fields.project-contributors.view-profile': 'Profil anzeigen',
  'project-fields.project-contributors.view-profile-team': 'Profil anzeigen',
  'project-fields.project-focus-areas.title': 'Schwerpunktbereiche',
  'project-fields.project-followers.add-followers-title': 'Follower hinzufügen',
  'project-fields.project-followers.empty-title': 'Keine Follower',
  'project-fields.project-followers.title': 'Follower',
  'project-fields.project-link-picker.aria-label': 'Zuletzt aufgerufene Links',
  'project-fields.project-link-picker.invalid-link-input.error':
    'Bitte überprüfen Sie, ob die URL Ihres Links gültig ist.',
  'project-fields.project-link-picker.link-input.clear-label': 'Link löschen',
  'project-fields.project-link-picker.link-input.placeholder': 'Link einfügen oder kürzlich angesehene suchen',
  'project-fields.project-link-picker.text-input.clear-label': 'Text löschen',
  'project-fields.project-link-picker.text-input.placeholder': 'Text zum Anzeigen (optional)',
  'project-fields.project-links.add-links-title': 'Links hinzufügen',
  'project-fields.project-links.add-links-tooltip': 'Dokumenten, Designs und mehr Links hinzufügen',
  'project-fields.project-links.delete-link-button': 'Link löschen',
  'project-fields.project-links.edit-link-button': 'Verknüpfung bearbeiten',
  'project-fields.project-links.empty-title': 'Keine Links',
  'project-fields.project-links.title': 'Links',
  'project-fields.project-owner.title': 'Besitzer',
  'project-fields.project-start-date.add-start-date-title': 'Startdatum hinzufügen',
  'project-fields.project-start-date.cancel-button': 'Speichern',
  'project-fields.project-start-date.creation-date': 'Dieses Projekt wurde am {creationDate} erstellt.',
  'project-fields.project-start-date.edit-start-date-label': 'Startdatum des Projekts bearbeiten',
  'project-fields.project-start-date.empty-title': 'Kein Startdatum',
  'project-fields.project-start-date.enter-start-date-title': 'Startdatum eingeben',
  'project-fields.project-start-date.open-calendar-label': 'Kalender öffnen',
  'project-fields.project-start-date.read-only':
    'Nur Beitragende mit Bearbeitungszugriff können das Startdatum ändern.',
  'project-fields.project-start-date.title': 'Startdatum',
  'project-fields.project-state.archived': 'Archiviert',
  'project-fields.project-state.at-risk': 'In Gefahr',
  'project-fields.project-state.cancelled': 'Abgebrochen',
  'project-fields.project-state.completed': 'Abgeschlossen 🎉',
  'project-fields.project-state.off-track': 'Nicht auf Kurs',
  'project-fields.project-state.on-track': 'Auf Kurs',
  'project-fields.project-state.paused': 'Angehalten',
  'project-fields.project-state.pending': 'Ausstehend',
  'project-fields.project-status-picker.project-status-picker-more-button': 'Weitere Status',
  'project-fields.project-status.title': 'Status',
  'project-fields.project-tags.add-tags-title': 'Tags hinzufügen',
  'project-fields.project-tags.empty-title': 'Keine Tags',
  'project-fields.project-tags.title': 'Tags',
  'project-fields.project-target-date.picker-placeholder': 'Ausstehend',
  'project-fields.project-target-date.title': 'Zieldatum',
  'project-fields.project-work-items.show-all-non-final': 'Alle anzeigen',
  'project-fields.project-work-items.show-less-non-final': 'Weniger anzeigen',
  'project-fields.project-work-tracked-picker.cancel-button': 'Speichern',
  'project-fields.project-work-tracked-picker.fallback-description':
    'Fügen Sie einen Link zu dem Ort hinzu, an dem Sie die Arbeit für dieses Projekt verfolgen.',
  'project-fields.project-work-tracked-picker.fallback-invalid-url': 'Bitte geben Sie eine gültige URL ein.',
  'project-fields.project-work-tracked-picker.no-recently-viewed-header': 'Nach Jira-Vorgängen suchen',
  'project-fields.project-work-tracked-picker.no-recently-viewed-result':
    'Suchen Sie nach Links zu Orten, an denen Sie Vorgänge für dieses Projekt verfolgen, oder fügen Sie Links zu solchen hinzu.',
  'project-fields.project-work-tracked-picker.no-search-result':
    'Geben Sie den Jira-Vorgangsschlüssel oder die URL erneut ein oder verwenden Sie andere Suchbegriffe.',
  'project-fields.project-work-tracked-picker.no-search-results-header': 'Keine Übereinstimmung gefunden',
  'project-fields.project-work-tracked-picker.recently-viewed-title': 'Kürzlich angesehen',
  'project-fields.project-work-tracked-picker.results-title': 'Ergebnisse',
  'project-fields.project-work-tracked-picker.search-placeholder': 'Jira durchsuchen oder Verknüpfung hinzufügen',
  'project-fields.project-work-tracked-picker.sync-form-description':
    'Verknüpfen Sie dieses Projekt mit dem ausgewählten Jira-Vorgang und sorgen Sie so dafür, dass Details automatisch synchron bleiben.',
  'project-fields.project-work-tracked-picker.sync-form-warning':
    'Beachten Sie, dass jeder, der diesen Jira-Vorgang sehen kann, auch Ihre Projektdetails sehen kann.',
  'project-fields.project-work-tracked-picker.sync-with-jira-button': 'Mit Jira synchronisieren',
  'project-fields.project-work-tracked-picker.sync-with-jira-cancel-button': 'Abbrechen',
  'project-fields.project-work-tracked-picker.sync-with-jira-connect-button': 'Verbinden',
  'project-fields.project-work-tracked-picker.sync-with-jira-detail-selection':
    'Wählen Sie die Details aus, die Sie in Zukunft für diese Arbeit verwenden möchten:',
  'project-fields.project-work-tracked-picker.sync-with-jira-header': 'Dieses Projekt mit Jira synchronisieren',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing': 'Stichwortsynchronisierung',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing-description':
    'Stichwörter aus Jira mit Tags im Projekt synchronisieren',
  'project-fields.project-work-tracked-picker.sync-with-jira-project-name': 'Projektname',
  'project-fields.project-work-tracked-picker.sync-with-jira-start-date': 'Startdatum',
  'project-fields.project-work-tracked-picker.sync-with-jira-target-date': 'Zieldatum',
  'project-fields.project-work-tracked-picker.sync-with-jira-via-project': '{projectName} {viaProject}',
  'project-fields.project-work-tracked-picker.text-placeholder': 'Verknüpfung zur Arbeitsverfolgung',
  'project-fields.project-work-tracked-picker.work-tracked-picker-content':
    'Suchen Sie nach Jira-Vorgängen oder fügen Sie Links zu Orten hinzu, an denen Sie Aufgaben für dieses Projekt verfolgen.',
  'project-fields.project-work-tracked-picker.work-tracked-picker-title': 'Wo wird die Arbeit verfolgt?',
  'project-fields.project-work-tracked.add-work-tracked-title': 'Jira-Vorgänge hinzufügen',
  'project-fields.project-work-tracked.empty-title': 'Keine Jira-Vorgänge',
  'project-fields.project-work-tracked.linked-with-jira-label': 'Verknüpft mit Jira',
  'project-fields.project-work-tracked.sync-now-label': 'Jetzt synchronisieren',
  'project-fields.project-work-tracked.synced-with-jira-label': 'Synchronisiert mit Jira',
  'project-fields.project-work-tracked.title': 'Verfolgte Vorgänge',
  'project-fields.related-project-picker.add-button-label': 'Hinzufügen',
  'project-fields.related-project-picker.cancel-button-label': 'Abbrechen',
  'project-fields.related-project-picker.depended-by-option-label': 'Vom Projekt ist abhängig',
  'project-fields.related-project-picker.depends-on-option-label': 'Projekt ist abhängig von',
  'project-fields.related-project-picker.empty-state-description':
    'Finden Sie verwandte Projekte, um sie mit diesem Projekt zu verknüpfen.',
  'project-fields.related-project-picker.empty-state-title': 'Nach Projekten suchen',
  'project-fields.related-project-picker.project-relationship-type-label': 'Art der Projektbeziehung auswählen',
  'project-fields.related-project-picker.project-search-placeholder': 'Projekte suchen',
  'project-fields.related-project-picker.related-option-label': 'Projekt hängt zusammen mit',
  'project-fields.related-project-picker.related-project-list-label': 'Verwandte Projekte',
  'project-fields.related-projects.add-related-title': 'Verwandte Projekte hinzufügen',
  'project-fields.related-projects.add-related-tooltip': 'Abhängige oder verwandte Projekte hinzufügen',
  'project-fields.related-projects.dependent-by-projects-heading': 'Abhängig von',
  'project-fields.related-projects.dependent-on-projects-heading': 'Abhängig von',
  'project-fields.related-projects.empty-title': 'Keine zugehörigen Projekte',
  'project-fields.related-projects.related-projects-heading': 'Zugehörig',
  'project-fields.related-projects.title': 'Zugehörig',
  'project-fields.use-project-flags.generic-error-description':
    'Etwas ist schiefgelaufen. Versuchen Sie es in ein paar Minuten erneut.',
  'project-fields.use-project-flags.generic-error-title': 'Etwas ist schiefgelaufen',
  'project-fields.use-project-flags.project-links-add-failure-title': 'Link konnte nicht hinzugefügt werden',
  'project-fields.use-project-flags.project-links-delete-failure-title': 'Link konnte nicht entfernt werden',
  'project-fields.use-project-flags.project-links-edit-failure-title': 'Link konnte nicht bearbeitet werden',
  'project-fields.use-project-flags.project-owner-change-error-header': 'Projektbesitzer konnte nicht geändert werden',
  'project-fields.use-project-flags.project-start-date-change-error-header':
    'Das Startdatum des Projekts konnte nicht aktualisiert werden',
  'project-fields.use-project-flags.project-tags-add-failure-title': 'Tag konnte nicht hinzugefügt werden',
  'project-fields.use-project-flags.project-tags-create-failure-title': 'Tag konnte nicht erstellt werden',
  'project-fields.use-project-flags.project-tags-create-limit-failure-description':
    'Der eingegebene Tag-Name ist zu lang. Bitte geben Sie einen Tag-Namen mit maximal 255 Zeichen ein.',
  'project-fields.use-project-flags.project-tags-create-limit-failure-title': 'Tag konnte nicht erstellt werden',
  'project-fields.use-project-flags.project-tags-remove-failure-title': 'Tag konnte nicht entfernt werden',
  'project-fields.use-project-flags.project-team-remove-failure-description':
    'Fehler beim Entfernen des Teams, bitte versuchen Sie es erneut',
  'project-fields.use-project-flags.related-project-remove-failure-title':
    'Zugehöriges Projekt konnte nicht entfernt werden',
};
